
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/asia-cup-2025/[slug]/commentary",
      function () {
        return require("private-next-pages/sports/asia-cup-2025/[slug]/commentary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/asia-cup-2025/[slug]/commentary"])
      });
    }
  